var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import html2pdf from "html2pdf.js";
import QRCode from "qrcode";
import { cancelarCertidaoCondutor } from "../../services/habilitacao.service";
import { FormButton, FormButtonType } from "../FormButton";
import { Modal } from "../Modal";
import { SnackbarFeedback } from "../SnackbarFeedback";
import { ViewPdf } from "../ViewPdf";
export var CardCertidao = function (_a) {
    var certidao = _a.certidao;
    var navigate = useNavigate();
    var _b = useState(false), modalExcluirCertidao = _b[0], setModalExcluirCertidao = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState(false), sucess = _e[0], setSucess = _e[1];
    var _f = useState(undefined), base64 = _f[0], setBase64 = _f[1];
    var handleCancel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var html, regex, match, numeroCertidao, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoading(true);
                    setErrorMessage(undefined);
                    html = certidao.texto;
                    regex = /CERTID&Atilde;O DE CONDUTOR N&ordm; (\d+)/;
                    match = html.match(regex);
                    if (!match) return [3 /*break*/, 6];
                    numeroCertidao = match[1];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, cancelarCertidaoCondutor(numeroCertidao)];
                case 2:
                    _d.sent();
                    setSucess(true);
                    setTimeout(function () {
                        navigate(0);
                    }, 1000);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    setErrorMessage((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao excluir a certidão de condutor");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setModalExcluirCertidao(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 7];
                case 6:
                    setErrorMessage("Erro ao excluir a certidão de condutor");
                    setLoading(false);
                    setModalExcluirCertidao(false);
                    _d.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleGetPdfBase64 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var element, validationCode, qrCodeDataUrl, opt, pdf;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    element = document.createElement("div");
                    element.innerHTML = certidao.texto;
                    validationCode = certidao.codigoValidacao;
                    return [4 /*yield*/, QRCode.toDataURL("https://validacao.detran.mt.gov.br/validar?validationCode=".concat(validationCode))];
                case 1:
                    qrCodeDataUrl = _a.sent();
                    element.innerHTML = element.innerHTML.replace("#qrcode#", "<img src=\"".concat(qrCodeDataUrl, "\" alt=\"QR Code\" style=\"width: 80px; height: 80px;\" />"));
                    element.style.width = "190mm";
                    element.style.fontSize = "12px";
                    element.style.padding = "10px";
                    element.style.boxSizing = "border-box";
                    opt = {
                        margin: 10,
                        image: { type: "jpeg", quality: 0.98 },
                        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
                        html2canvas: {
                            scale: 2,
                            useCORS: true,
                        },
                        pagebreak: { mode: "avoid-all" },
                    };
                    return [4 /*yield*/, html2pdf().from(element).set(opt).output('datauristring')];
                case 2:
                    pdf = _a.sent();
                    setBase64(pdf.split(',')[1]);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Stack, __assign({ boxShadow: "1", borderRadius: "0.25rem", mb: "1rem", sx: { backgroundColor: "white" } }, { children: [_jsxs(Stack, __assign({ flexDirection: "row", justifyContent: "space-between", padding: "0.75rem" }, { children: [_jsx(Stack, __assign({ flexDirection: "row", alignItems: "start", gap: "1rem" }, { children: _jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body1", fontSize: "1.125rem", fontWeight: "500" }, { children: "Certid\u00E3o do Condutor" })), _jsxs(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: ["Data Emiss\u00E3o: ", certidao.dataEmissao] }))] }) })), _jsxs(Stack, __assign({ direction: "row", gap: "1rem" }, { children: [_jsx(FormButton, { title: "EMITIR", type: FormButtonType.PRIMARY, onClick: handleGetPdfBase64 }), _jsx(FormButton, { title: "EXCLUIR", type: FormButtonType.CANCEL_PRIMARY, onClick: function () { return setModalExcluirCertidao(true); } })] }))] })), _jsx(Modal, { open: modalExcluirCertidao, onClose: function () { return setModalExcluirCertidao(false); }, title: !loading ? "Atenção" : _jsx(CircularProgress, {}), subTitle: !loading ? "Deseja cancelar a certidão emitida anteriormente?" : "", buttons: [
                    _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Sim", onClick: handleCancel }, 0),
                    _jsx(FormButton, { type: FormButtonType.CANCEL_SECONDARY, title: "N\u00E3o", onClick: function () { return setModalExcluirCertidao(false); } }, 1),
                ], directionButtons: "row-reverse" }), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: "Certid\u00E3o do Condutor" })), errorMessage && (_jsx(SnackbarFeedback, { isOpen: !!errorMessage, message: errorMessage, type: "error" })), sucess && (_jsx(SnackbarFeedback, { isOpen: true, type: "success", message: "Solicita\u00E7\u00E3o realizada com sucesso" }))] })));
};
